import { getUrlParamsMapV2, isValidDate } from '../../../common/utils/browserUtils';
import { DEFAULT_DEPARTURE_CITY } from '../constants/searchConstants';
import { getFromCities } from '../services';
import { getReqDataSsr } from '../../helpers/utils';

export const SET_TO_CITY = 'SET_TO_CITY';
export const SET_FROM_CITY = 'SET_FROM_CITY';
export const SET_TRAVEL_DATE = 'SET_TRAVEL_DATE';
export const SET_DEFAULT_SEARCH = 'SET_DEFAULT_SEARCH';
export const SET_URL_SEARCH_PARAMS = 'SET_URL_SEARCH_PARAMS';
export const GET_SEARCH_LIST = 'GET_SEARCH_LIST';
export const SET_FROM_CITIES_LIST = 'SET_FROM_CITIES_LIST';
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const UPDATE_DESTINATION_META = 'UPDATE_DESTINATION_META';

export const setTravelDateAction = payload => ({
  type: SET_TRAVEL_DATE,
  payload,
});

export const setCityAction = (payload, field) => ({
  type: field === 'fromCity' ? SET_FROM_CITY : SET_TO_CITY,
  payload,
});

export const setSearchTextAction = searchText => ({
  type: SET_SEARCH_TEXT,
  payload: searchText,
});
export const updateInitialValuesFromUrlAction = requestParam => {
  // eslint-disable-next-line no-undef
  const queryParamMap = ssr.isOnClient ? getUrlParamsMapV2() : getReqDataSsr(requestParam);
  const urlSearchParams = {};
  if (queryParamMap.dest) {
    urlSearchParams.toCity = queryParamMap.dest.replace(/\+/g, ' ');
    urlSearchParams.destValue =
      queryParamMap.destValue?.replace(/\+/g, ' ') || urlSearchParams.toCity;
  }
  if (queryParamMap.destValue) {
    urlSearchParams.destValue = queryParamMap.destValue?.replace(/\+/g, ' ');
  }
  if (queryParamMap.depCity) {
    urlSearchParams.fromCity = queryParamMap.depCity.replace(/\+/g, ' ');
  }
  if (queryParamMap.destCode) {
    urlSearchParams.toCityCode = queryParamMap.destCode.replace(/\+/g, ' ');
  }
  if (queryParamMap.depCityCode) {
    urlSearchParams.fromCityCode = queryParamMap.depCityCode.replace(/\+/g, ' ');
  } else {
    urlSearchParams.fromCity = queryParamMap.depCity || DEFAULT_DEPARTURE_CITY;
  }
  if (isValidDate(queryParamMap.dateSearched)) {
    const dateStrArr = queryParamMap.dateSearched.split('/');
    if (dateStrArr.length === 3) {
      urlSearchParams.travelDate = new Date(
        dateStrArr[2],
        Number(dateStrArr[1]) - 1,
        dateStrArr[0]
      );
    }
  }
  if (queryParamMap.campaign) {
    urlSearchParams.campaign = queryParamMap.campaign.replace(/\+/g, ' ');
  }
  if (queryParamMap.packageIds) {
    urlSearchParams.packageIds = queryParamMap.packageIds.split(',');
  }
  if (queryParamMap.tagDestination) {
    urlSearchParams.tagDestination = queryParamMap.tagDestination.replace(/\+/g, ' ');
  }
  return {
    type: SET_DEFAULT_SEARCH,
    payload: urlSearchParams,
  };
};

export const getSearchListAction = () => async dispatch => {
  try {
    const fromCities = await getFromCities();
    dispatch(setFromCitiesList(fromCities?.data));
  } catch (error) {
    console.error(error);
  }
};

export const setFromCitiesList = data => ({
  type: SET_FROM_CITIES_LIST,
  payload: data,
});
export const updateDestinationMeta = payload => ({
  type: UPDATE_DESTINATION_META,
  payload,
});
